import "./polyfills.js";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import "normalize.css";
import "./styles/main";
import App from "./components/App";
import { setAuthToken } from "./actions/authDrawer";
import { getUserData } from "./actions/user";
import { getLocalItem } from "./utils/localdb";

if (typeof window !== "undefined") {
  var preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  var store = configureStore(preloadedState);

  var token = getLocalItem("authToken");
  if (token) {
    store.dispatch(setAuthToken(token)).then(function () {
      return store.dispatch(getUserData());
    });
  }

  var render = function render() {
    (preloadedState ? ReactDom.hydrate : ReactDom.render)(React.createElement(
      Provider,
      { store: store },
      React.createElement(App, null)
    ), document.getElementById("app"));
  };

  if (module.hot) {
    module.hot.accept("./components/App", function () {
      render();
    });
  }

  render();
}


// WEBPACK FOOTER //
// ./src/browser.js